import { sharedLocalStorage } from '@/shared/helpers';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { tokenIsExpired } from '../helpers';
import { decodeToken } from './decodeToken';
const initialState = {
    token: undefined,
    expiration: undefined,
    // user: undefined,
    // userClaims: [],
    // userCrossdocks: [],
    // userStockLocations: [],
    loginDialog: {
        isTryingToLogin: false,
        isError: false,
        error: '',
    },
};
const useAuthStore = create()(immer((set) => ({
    ...initialState,
    setIsTryingToLogin: (value) => set((state) => {
        state.loginDialog.isTryingToLogin = value;
    }),
    setLoginError: (isError, errorMessage) => set((state) => {
        state.loginDialog.isError = isError;
        state.loginDialog.error = errorMessage;
    }),
    // 	expiration: number;
    // 	userId: number;
    // 	userFullName: string;
    // 	userEmail: string;
    // 	avatar: string | null;
    // 	roles: string[];
    // claims: ClaimId[];
    // locationIds: number[];
    // crossDockIds: number[];
    // }
    // // authSuccess: (token, user) =>
    // authSuccess: (token) =>
    // 	set((state) => {
    // 		// const { claims, locationIds, crossDockIds, ...other } = user;
    // 		// TODO: check if we actually need token inside state.
    // 		state.token = token;
    // 		// state.user = other;
    // 		// state.userClaims = claims ?? [];
    // 		// state.userCrossdocks = crossDockIds ?? [];
    // 		// state.userStockLocations = locationIds ?? [];
    // 		if (token) {
    // 			coreLocalStorage.setItem('token', token);
    // 			state.expiration = decodeToken(token).expiration;
    // 		}
    // 		// Store both 'user' and 'userClaims' data to prevent unnecessary claims calculation and extra role dictionary fetching inside useAuth hook.
    // 		// if (user) coreLocalStorage.setItem('userData', JSON.stringify(user));
    // 	}),
    useToken: (token) => set((state) => {
        state.token = token;
        if (!token)
            return;
        const expiration = decodeToken(token).expiration;
        if (tokenIsExpired(expiration)) {
            sharedLocalStorage.removeItem('token');
            return;
        }
        state.expiration = expiration;
    }),
    signOut: () => {
        set(initialState);
        sharedLocalStorage.removeItem('token');
        // Navigation will be performed in <RequireAuth> component with proper redirection. `.replace('/login')` loses
        // redirect path.
        // window.location.replace('/login');
    },
})));
export { useAuthStore };
